<template lang="">
  <section class="register-form">
    <div class="row no-gutters ">
      <div class="col-md-6 m-auto text-center">
        <img :src="bank" alt="" class="bankimge" />
        <p class="bank" v-if="motorProductType==='4W-Pvt'">
          Save <b>upto 30%</b> on 
          your 
          Car insurance
          in a minute
        </p>
        <p class="bank" v-if="motorProductType==='2W-Pvt'">
          Save <b>upto 20%</b> on 
          your 
          Bike insurance
          in a minute
        </p>
      </div>
      <div class="col-md-6">
        <div class="card">
          <form>
            <div class="form-group">
              
              <input
                type="text"
                class="form-control"
                id="registration-number"
                v-model.trim="userData.vehicleNumber"
                placeholder="Enter Registration Number"
                maxlength="14"
                @keypress="alphanumeric($event)"
                @paste="alphanumeric($event)"
                @input="validateRegistrationNumber(userData.vehicleNumber)"
              />
              <small id="emailHelp" class="form-text d-flex gap-1 align-items-center"
                >
                <img src="../../assets/images/info.svg" alt="" > 
                    Eg. MH12UP7358 or 22BH2345HH
            </small>
            <p class="error-text mb-2" v-if="registrationNoError">{{registrationNoError }}</p>

            <input
                type="number"
                class="form-control mt-3"
                id="mob-number"
                v-model.trim="userData.mobileNumber"
                placeholder="Mobile Number"
                @keypress="isNumber($event)"
                @paste="onPaste($event)"
                maxlength="10"
                @input="getFieldValidation('mobile',$event)"
              
              />
              <p class="error-text mb-2" v-if="error.mobile">{{ error.mobile }}</p>

              <input
                type="text"
                class="form-control mt-3"
                id="email"
                v-model.trim="userData.email"
                placeholder="Email"
                @input="getFieldValidation('email',$event)"
              />
              <p class="error-text mb-2" v-if="error.email" style="color: red;">{{ error.email }}</p>
              <!-- <input
                type="text"
                class="form-control mt-3"
                id="pin-code"
                v-model.trim="userData.pinCode"
                placeholder="Pin Code"
                pattern="[0-9]{6}"              
                :maxlength="6"
                @input="getFieldValidation('pinCode',$event)"
                @keypress="isNumber($event)"


              />
              <p class="error-text" v-if="error.pinCode">{{ error.pinCode }}</p> -->
              
              <!-- Vahan API Error Message -->
              <div v-if="vahanError" class="mt-3 d-flex align-items-center justify-content-between">
                <p class="vahan_highlight_error mb-0" v-if="vahanError" style="color: red;">{{ vahanError }}</p>
                <span class="mb-0 vahan_highlight_error">{{timeRemain}}s</span>
              </div>
              
              <button class="btn commonButton mt-3" :class="{'disabledButton': checkformData()}" :disabled="incorrectData || loading" @click.prevent="searchVehicle"> 
                <span v-if="loading">Loading...</span>
                <span v-else>Continue</span>
              </button>
              <div class="d-flex align-items-center justify-content-center mt-4">
                <p class="subhead mb-0" v-if="motorProductType==='4W-Pvt'" >
                   Bought a new car?
                </p>
                <p class="subhead mb-0" v-if="motorProductType==='2W-Pvt'" >
                   Bought a new bike?
                </p>
          <router-link to="/form-Wizard" class="nextpagerout new-vehicle-click" @click="setquoteCategory()">Click here</router-link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { getLandingImgs, getDistributer } from "@/mixins/common";
import backendApi from "@/apis/axios-backend";
import store  from 'vuex';
export default {
  data() {
    return {
      bank: "",
      rto:"",
      registrationNoError:"",
      error:[],
      incorrectData: true,
      loading:false,
      motorProductType:'',
      userInfo:{},
      reqBody:{},
      userData:{
        mobileNumber:sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData")).mobileNumber : null,
        email: sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData")).email : null,
        pinCode:null,
        vehicleNumber:sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData")).vehicleNumber : null,
        state:null,
        city:null,
        rto:null,
      },
      vahanError: null,
      vahanApiCalled: false,
      timeRemain: 3,
      distributorID: "",
    };
  },
  async mounted() {
    sessionStorage.setItem("userData",JSON.stringify(this.userData));
    this.distributorID = getDistributer()["distributerID"];
    //remving oddata so not open 9th step
    if(sessionStorage.getItem("userData")){
      const userdata=JSON.parse(sessionStorage.getItem("userData"));
      userdata.OdDate="";
      sessionStorage.setItem("userData",JSON.stringify(userdata));
    }
    sessionStorage.removeItem("rtoCode");
    this.bank = getLandingImgs().BANK;
    this.motorProductType=this.$store.state.motorProductType;
    if(sessionStorage.getItem("userData")){
      this.userInfo = JSON.parse(sessionStorage.getItem("userData"));
      this.userData.vehicleNumber = this.userInfo.vehicleNumber;
      // this.userData.mobileNumber = this.userInfo.mobileNumber;
      // this.userData.pinCode = this.userInfo.pinCode;
      sessionStorage.removeItem("userSelection")
    }
    this.timeRemain = 3;
    const isPreFilled = getDistributer()['isPreFilled'];
    if (this.$store.state.customerData && isPreFilled) {
      const customerData = this.$store.state.customerData;
      this.userData.pinCode = customerData.communicationAddress.zipCode;
      this.userData.mobileNumber = customerData.personalInformation.mobileNumber;
      this.userData.state = customerData.communicationAddress.state;
      this.userData.city = customerData.communicationAddress.city;
      // this.error["pinCode"] = this.userData.pinCode !== '' ? '' : "Please enter a valid Pincode"; 
      // await this.getPincode(this.userData.pinCode);
      this.error["mobile"] = this.userData.mobile !== '' ? '' : "Please enter a valid mobile number"; 
      this.checkformData();
    }
    this.focusRegField()
    this.handleDeeplink();
  },
  methods: {
    handleDeeplink() {
      const { mobile, email, registrationNo } = this.$store.state.deepLinkParams;
      if (mobile) {
        this.userData.mobileNumber = mobile;
        this.getFieldValidation('mobile', { target: { value: mobile } });
      }
      if (email) {
        this.userData.email = email;
        this.getFieldValidation('email', { target: { value: email } });
      }
      if (registrationNo) {
        this.userData.vehicleNumber = String(registrationNo).toUpperCase();
        this.validateRegistrationNumber(this.userData.vehicleNumber);
      }
      this.checkformData();
      if (mobile || email || registrationNo) {
        this.searchVehicle();
      }
    },
    setquoteCategory(){
      if(sessionStorage.getItem("vahanData")){
        sessionStorage.removeItem("vahanData")
      }
      this.$store.commit("setquoteCategory","New");
    },
    focusRegField(){
      let regField = document.querySelector("#registration-number");
      regField.focus();
    },
    getRto() {
      if (this.userData.vehicleNumber) {  
        const match = this.userData.vehicleNumber.match(/^([A-Z]{2}-?[0-9]{2})/);
        this.rto = match ? match[1] : null;
        console.log("this.rto",this.rto);
        sessionStorage.setItem("rtoCode",JSON.stringify(this.rto));
      } else {
        this.rto = null; 
      }
  },
    async searchVehicle(){
      if(!this.userData.vehicleNumber || !this.userData.mobileNumber || !this.userData.email){
        if(!this.userData.vehicleNumber){
          this.registrationNoError = "Please enter Registration Number"
        }
        if(!this.userData.mobileNumber){
          this.error.mobile = "Please enter Mobile number"
        }
        if(!this.userData.email){
          this.error.email = "Please enter Email address"
        }
        return;
      }

      this.getRto();
      this.$store.commit("setquoteCategory","Roll-Over");
      
      // If Vahan API was already called successfully or there was an error, proceed without calling API again
      if (this.vahanApiCalled || this.vahanError) {
        this.$router.push({ name: "formWizard" });
        this.loading = true;
        console.log(this.userData);
        sessionStorage.setItem("userData",JSON.stringify(this.userData));
        return;
      }
      
      // Call Vahan API for the first time
      try {
        this.loading = true;
        this.vahanError = null;
        
        let rmData = JSON.parse(sessionStorage.getItem("rm_data"));
        const request = {
          "distributor": {
            "distributorID": this.distributorID,
            "agentID": this.getAgentIdFromRmData(rmData),
            "salesChannel": "",
            "channelType": rmData.RoleId !== "1" ? "B2B" : "B2C",
            "varFields": [
              {
                "fieldName": "",
                "fieldValue": ""
              }
            ]
          },
          "mobileNumber": String(this.userData.mobileNumber),
          "registrationNumber": String(this.userData.vehicleNumber),
          "varFields": [
            {
              "fieldName": "manufacturerUniqueNo",
              "fieldValue": ""
            }
          ]
        };
        
        const response = await this.backendApi("vahanSearch", request, {"Authorization":`Bearer ${this.$store.state.token}`}, "post");
        
        if (response && response.data && response.data.errors && response.data.errors.length > 0) {
          // API returned errors
          this.vahanError = "Parivahan data not available, please continue manually"
          this.handleTimer();
          this.loading = false;
        } else if (response && response.data && response.data.data) {
          if(response.data.data.product.motorProductType !== this.motorProductType){
            this.vahanError ="Parivahan data not available, please continue manually";
            this.handleTimer();
            this.loading = false;
          }else if(!response?.data?.data?.rtoLocationCode){
            // If rtoLocationCode is not present, stop on first page (same as error handling)
            this.vahanError = "RTO location code not available, please continue manually";
            this.handleTimer();
            this.loading = false;
          }else{
            // API success - store the response and proceed
            sessionStorage.setItem("vahanData", JSON.stringify(response.data.data));
            this.vahanApiCalled = true;
            this.loading = false;
            
            // Set rtoCode before navigation
            this.userData.rtoCode = response?.data?.data?.rtoLocationCode;
            sessionStorage.setItem(
              "userData",
              JSON.stringify(this.userData)
            );
            
            // Proceed to form wizard
            this.$router.push({ name: "formWizard" });
          }
        } else {
          // Unexpected response
          this.vahanError = "Parivahan data not available, please continue manually";
          this.handleTimer();
          this.loading = false;
        }
        
      } catch (error) {
        console.error("Error in Vahan API:", error);
        this.vahanError = "Parivahan data not available, please continue manually";
        this.handleTimer();
        this.loading = false;
      }
    },
    handleTimer(){
      setInterval(() => {
        this.timeRemain -= 1;
        if(this.timeRemain == 1){
          setTimeout(() => {
            this.searchVehicle();
          }, 500);
        }
      }, 1000);
      this.timeRemain = 3;
    },
    validateRegistrationNumber(vehicleNumber){
      this.userData.vehicleNumber = this.userData.vehicleNumber.toUpperCase(); 
      const enteredNumber = vehicleNumber.toUpperCase(); 
      const regEx =/^[A-Z]{2}\d{2}(?:[A-Z]{1,3}|)\d{4}$/;
      const regExbharat =/^\d{2}BH(000[1-9]|00[1-9]\d|0[1-9]\d{2}|[1-8]\d{3}|9990)([A-HJ-NP-Z]{1,2})$/;

      // Clear Vahan error and reset API call flag when vehicle number changes
      this.vahanError = null;
      this.vahanApiCalled = false;
      // Clear stored Vahan data
      sessionStorage.removeItem("vahanData");
      
      if (!regEx.test(enteredNumber) && !regExbharat.test(enteredNumber)) {
        this.registrationNoError = 'Kindly enter a valid registration number';
      } else {
        this.registrationNoError = "";
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var inputValue = evt.target.value;
      if (inputValue?.length >= 10) {
        evt.preventDefault();
      }
      if ((inputValue === "0" && inputValue.length > 0) || (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    alphanumeric(evt) {
      evt = evt || window.event;

      // Handle keypress: allow only alphanumeric keys
      if (evt.type === 'keypress') {
        const charCode = evt.which || evt.keyCode;
        if (
          (charCode >= 48 && charCode <= 57) || // 0-9
          (charCode >= 65 && charCode <= 90) || // A-Z
          (charCode >= 97 && charCode <= 122)   // a-z
        ) {
          return true;
        } else {
          evt.preventDefault();
        }
      }

      // Handle paste: clean the pasted content
      if (evt.type === 'paste') {
        evt.preventDefault(); // Stop the default paste

        let pastedData = (evt.clipboardData || window.clipboardData).getData('text');
        let cleaned = pastedData.replace(/[^a-zA-Z0-9]/g, ''); // Remove non-alphanumeric

        // Insert the cleaned value into the input field
        const input = evt.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;

        const newValue = 
          input.value.substring(0, start) + cleaned + input.value.substring(end);

        input.value = newValue;

        // Trigger v-model update manually if using Vue
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
      }
    },
   onPaste(event) {
    event.preventDefault();

  const clipboardData = event.clipboardData || window.clipboardData;
  let pasted = clipboardData.getData("Text") || "";

 pasted = pasted.replace(/\./g, "").replace(/\D/g, "");

  const input = event.target;
  const start  = input.selectionStart;
  const end   = input.selectionEnd;

  const before = input.value.slice(0, start);
  const after = input.value.slice(end);

  const newVal = (before + pasted + after).slice(0, 10);

  // Update input visually
  input.value = newVal;


  this.userData.mobileNumber = newVal;

  
  this.getFieldValidation("mobile", { target: { value: newVal } });
}
,
    getFieldValidation(name,event){
      if(name=="mobile"){
        const regex = /^[6789]\d{9}$/;
        if(regex.test(this.userData.mobileNumber)){
          this.error["mobile"]=""
        }else{ 
          this.error["mobile"] = "Please enter a valid mobile number";
        }
      }
      else if (name=="pinCode") {
          if(this.userData.pinCode && event.target.value.length==6){
            this.getPincode(this.userData.pinCode);        
          }
        else {
          this.incorrectData = true;
          this.error["pinCode"] = "Please enter a valid Pincode";
        }
      }else if (name=="email") {
        const value = event.target.value;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailPattern.test(value)) {
          this.error["email"]=""
        }else{
          this.error["email"] = "Please enter a valid Email";
        }
      }
    },
    checkformData(){
      
      if (!this.error["mobile"] && !this.error["email"] && this.registrationNoError == "" && this.userData.vehicleNumber!=null){ 
        this.incorrectData = false;
      }
      else {
        this.incorrectData = true;
      }
   },
    async getPincode(pincode) {
      this.incorrectData = true;
      let headers = {};
      let reqData = [pincode];

      try {
        const response = await this.backendApi("getPincodeInfo", reqData, headers, "get");

        if (response?.data?.errors?.length > 0) {
          this.incorrectData = true;
          this.error["pinCode"] = "Please enter a valid Pincode";
        } else if (response?.data) {
          this.incorrectData = false;
          this.error["pinCode"] = '';
        }
      } catch (error) {
        this.incorrectData = true;
        console.log('error msg block dp', error);
        const msg = "Service is Unavailable, Please try again later.";
        this.$router.push({ path: '/error-page', query: { backUrl: 'New-Journey', msg: msg } });
      }
    },
   
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/register-form";
</style>
